import { render, staticRenderFns } from "./Flag.vue?vue&type=template&id=8765dc88&scoped=true&"
import script from "./Flag.vue?vue&type=script&lang=js&"
export * from "./Flag.vue?vue&type=script&lang=js&"
import style0 from "./Flag.vue?vue&type=style&index=0&id=8765dc88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8765dc88",
  null
  
)

export default component.exports